<template>
	<div class="preview" :empty="unitList.length == 0">
		<template v-for="(unit, j) in unitList">
			<div v-if="insertIndex == j" class="insert-line"></div>
			<unit-handle
				:key="unit.page_control_id"
				:type="type"
				:index="j"
				:name="unit.control_name"
				:uid="unit.page_control_id"
				:code="unit.control_code"
				:editable="unit.is_edit == 1"
				:delete-button="unit.is_can_delete == 1 && unit.load_type != 2"
				:switch-button="unit.is_can_enable == 1"
				:after="unitList[j+1]"
				:active="unit.state == 1"
			>
				<unit-comp-pc v-if="type == 'pc'" :unit="unit"></unit-comp-pc>
				<unit-comp-app v-else :unit="unit"></unit-comp-app>
			</unit-handle>
		</template>
		<div v-if="insertIndex == unitList.length" class="insert-line"></div>
	</div>
</template>

<script>
	import unitHandle from './unit_handle.vue'
	import unitCompPc from './preview_pc.vue'
	import unitCompApp from './preview_app.vue'
	import {mapState, updateState} from '@/components/createStore.js'
	import global from '@/assets/script/function';
	
	export default {
		components: {
			unitHandle,
			unitCompPc,
			unitCompApp
		},
		
		props: {
			type: String,
			page: Object,
			unitList: Array
		},
		
		data() {
			return {
				insertIndex: -1
			}
		},
		
		computed: {
			...mapState('decorate', ['dragUnit', 'dragUnitPosition'])
		},
		
		watch: {
			dragUnitPosition(val) {
				!val && this.insertHandle();
				this.dragHandle();
			}
		},
		
		methods: {
			dragHandle: global.throttle(function() {
				var client = this.$el.getBoundingClientRect();
				var minX = client.left;
				var maxX = minX + client.width;
				var minY = client.top < 59 ? 59 : client.top;
				var maxY = minY + client.height;
				
				if (this.dragUnitPosition && this.dragUnitPosition.x >= minX && this.dragUnitPosition.x <= maxX && this.dragUnitPosition.y >= minY && this.dragUnitPosition.y <= maxY) {
					if (this.unitList.length == 0) {
						this.insertIndex = 0;
					} else {
						for (let i = 0; i < this.unitList.length; i++) {
							let $child = this.$children.find(item => item.uid == this.unitList[i].page_control_id);
							let client = $child.$el.getBoundingClientRect();
						
							if (this.dragUnitPosition.y < client.top + client.height / 2) {
								this.insertIndex = i;
								break;
							} else if (i == this.unitList.length - 1) {
								this.insertIndex = this.unitList.length;
							}
						};
					}
				} else {
					this.insertIndex = -1;
				}
			}),
			
			insertHandle() {
				if (this.insertIndex > -1) {
					this.request({
						url: '/decoration/control/add',
						data: {
							page_id: this.page.page_id,
							control_id: this.dragUnit.control_id,
							sort_id: this.insertIndex
						},
						success: () => {
							this.$bus.$emit('updateUnitList');
						}
					});
				}
				updateState('decorate', 'dragUnit', false);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.preview {
		&[empty] {
			&:after {
				content: '可在此拖入控件';
				display: block;
				padding: 0 5px;
				line-height: 20px;
				font-size: 12px;
				color: #000;
			}
		}
	}
	
	.insert-line {
		z-index: 100;
		position: relative;
		outline: 1px solid #00BD8E;
		outline-width: 1px 0;
		
		&:before {
			content: '松开鼠标，控件将放置在这里';
			position: absolute;
			left: 0;
			top: -9px;
			width: 170px;
			line-height: 18px;
			font-size: 12px;
			text-align: center;
			color: #fff;
			background: #00BD8E;
		}
		
		&:after {
			content: '';
			position: absolute;
			top: -9px;
			left: 170px;
			border-width: 9px 0 9px 9px;
			border-style: solid;
			border-color: rgba(0,0,0,0) #00BD8E;
		}
	}
</style>
